module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/chieftain_small.05dd7e33.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/chieftain_small.png
// module id = 1026
// module chunks = 16